<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        :aria-labelledby="props.ariaLabelledby"
        :aria-hidden="!props.ariaLabelledby"
        role="img"
    >
        <path
            fill="currentColor"
            d="M4.667 14v-1.333h2.666V10.6a3.58 3.58 0 0 1-1.458-.692 2.986 2.986 0 0 1-.942-1.275 3.236 3.236 0 0 1-2.091-1.091A3.208 3.208 0 0 1 2 5.333v-.666c0-.367.13-.68.392-.942.26-.261.575-.392.941-.392h1.334V2h6.666v1.333h1.334c.366 0 .68.13.941.392.261.261.392.575.392.942v.666c0 .845-.28 1.58-.842 2.209a3.236 3.236 0 0 1-2.091 1.091c-.2.511-.514.936-.942 1.275a3.58 3.58 0 0 1-1.458.692v2.067h2.666V14H4.667Zm0-6.8V4.667H3.333v.666c0 .423.123.803.367 1.142.244.339.567.58.967.725Zm4.75 1.55c.389-.389.583-.861.583-1.417v-4H6v4c0 .556.194 1.028.583 1.417.39.389.861.583 1.417.583s1.028-.194 1.417-.583Zm1.916-1.55c.4-.144.723-.386.967-.725a1.91 1.91 0 0 0 .367-1.142v-.666h-1.334V7.2Z"
        />
    </svg>
</template>

<script setup lang="ts">
type TrophyIconProps = {
    ariaLabelledby?: string;
};

const props = defineProps<TrophyIconProps>();
</script>
